import DOMPurify from 'dompurify'

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    // Explicity allow elements Lexical uses, and default safe tags
    ALLOWED_TAGS: [
      'b','strong','i','em','u','p','br','ul','ol','li','blockquote','span','h1','h2','h3','h4','h5','h6','pre','code','div','table','tr','td','th','tbody','thead','a','hr'
    ],
    ALLOWED_ATTR: ['class','lang','dir','style','href','target','rel','colspan','rowspan']
  }) as string
}

export function textFromHtml(html: string): string {
  // Strip all tags by allowing none
  const stripped = DOMPurify.sanitize(html || '', { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }) as string
  // DOMPurify returns plain text; normalize whitespace
  return stripped.replace(/\s+/g, ' ').trim()
}

export function textWithLineBreaksFromHtml(html: string): string {
  const safeHtml = sanitizeHtml(html || '')

  const withBreakMarkers = safeHtml
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|blockquote|h[1-6]|tr)>/gi, '\n')

  const stripped = DOMPurify.sanitize(withBreakMarkers, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  }) as string

  const normalizedLines = stripped
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map(line => line.replace(/[ \t]+/g, ' ').trim())

  const compacted: string[] = []
  for (const line of normalizedLines) {
    if (!line) {
      if (compacted.length === 0 || compacted[compacted.length - 1] === '') {
        continue
      }
      compacted.push('')
      continue
    }
    compacted.push(line)
  }

  return compacted.join('\n').trim()
}
